import React, { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";

// PWA install helper. Android/Chrome: native install prompt. iOS Safari: a one-time
// "Add to Home Screen" hint (Apple gives no install-prompt API).
export default function InstallPWA() {
  const [promptEvent, setPromptEvent] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPromptEvent(e); window.__mykindInstallPrompt = e; };
    window.addEventListener("beforeinstallprompt", onPrompt);
    try { if (sessionStorage.getItem("rud_pwa_dismissed")) setDismissed(true); } catch (e) { /* noop */ }
    const ua = window.navigator.userAgent || "";
    const ios = /iphone|ipad|ipod/i.test(ua);
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    setIsIOS(ios && !standalone);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const close = () => { setDismissed(true); try { sessionStorage.setItem("rud_pwa_dismissed", "1"); } catch (e) { /* noop */ } };

  if (dismissed) return null;

  // iOS: manual "Add to Home Screen" hint
  if (isIOS && !promptEvent) {
    return (
      <div data-testid="install-pwa-ios" className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-sm z-40 rounded-2xl bg-[var(--rud-surface)] border border-brand/30 shadow-lg p-3 flex items-start gap-2.5">
        <img src="/mykind-icon.svg" alt="" className="w-8 h-8 mt-0.5" />
        <div className="flex-1 text-[13px] text-[var(--rud-text)]">
          <b>Install My Kind on your iPhone</b>
          <p className="text-sec text-[12px] mt-0.5 flex items-center gap-1 flex-wrap">
            Tap <Share size={14} className="inline text-brand" /> <b>Share</b> below, then choose <b>“Add to Home Screen”</b>.
          </p>
        </div>
        <button data-testid="install-pwa-ios-close" onClick={close} className="text-sec hover:text-[var(--rud-text)] p-1"><X size={15} /></button>
      </div>
    );
  }

  if (!promptEvent) return null;

  const install = async () => {
    promptEvent.prompt();
    try { await promptEvent.userChoice; } catch (e) { /* noop */ }
    setPromptEvent(null);
  };

  return (
    <div data-testid="install-pwa" className="fixed bottom-4 left-4 z-40 flex items-center gap-2 rounded-full bg-[var(--rud-surface)] border border-brand/30 shadow-lg pl-3 pr-2 py-2">
      <img src="/mykind-icon.svg" alt="" className="w-5 h-5" />
      <button data-testid="install-pwa-btn" onClick={install} className="text-sm flex items-center gap-1.5 text-[var(--rud-text)]">
        <Download size={15} className="text-brand" /> Install My Kind
      </button>
      <button data-testid="install-pwa-close" onClick={close} className="text-sec hover:text-[var(--rud-text)] p-1"><X size={14} /></button>
    </div>
  );
}
